import { Reducer } from "../../lib/redux";
import { UserHosRuleSetActionTypes } from "./types";
import UserHosRuleSet from "../../model/UserHosRuleSet";
import { UserHosRuleSetActions } from "./actions";
import { extend } from "../../utils/vanilla";

export let defaultUserHosRuleSets: IIdDictionary<IIdDictionary<UserHosRuleSet>> = {};

export let userHosRuleSets: Reducer<IIdDictionary<IIdDictionary<UserHosRuleSet>>, UserHosRuleSetActions> = (state = defaultUserHosRuleSets, action) => {
    switch (action.type) {
        case UserHosRuleSetActionTypes.SET_USER_HOS_RULESETS: {
            if (action.payload.userId) {
                return {
                    ...state,
                    [action.payload.userId]: extend(true, {}, action.payload.userHosRuleSets)
                };
            }
            return state;
        }
        case UserHosRuleSetActionTypes.CLEAR_USER_HOS_RULESETS: {
            const userId = action.payload;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return state;
        }
        default: {
            return state;
        }
    }
};
